import { useState, useMemo } from "react";
import { fmtCLP } from "../utils/formato";
import "./OpenCashModal.css";

// Denominaciones CLP (billetes y monedas)
const DENOMINACIONES = [
  { valor: 20000, label: "Billete $20.000" },
  { valor: 10000, label: "Billete $10.000" },
  { valor: 5000, label: "Billete $5.000" },
  { valor: 2000, label: "Billete $2.000" },
  { valor: 1000, label: "Billete $1.000" },
  { valor: 500, label: "Moneda $500" },
  { valor: 100, label: "Moneda $100" },
  { valor: 50, label: "Moneda $50" },
  { valor: 10, label: "Moneda $10" },
];

export default function OpenCashModal({ onCerrar, onConfirmar, cargando }) {
  const [montoDirecto, setMontoDirecto] = useState("");
  const [cantidades, setCantidades] = useState(() =>
    DENOMINACIONES.reduce((acc, d) => ({ ...acc, [d.valor]: "" }), {})
  );

  const totalPorDesglose = useMemo(() => {
    return DENOMINACIONES.reduce((sum, d) => {
      const q = parseInt(cantidades[d.valor], 10) || 0;
      return sum + d.valor * q;
    }, 0);
  }, [cantidades]);

  const usarDesglose = montoDirecto === "" || montoDirecto === "0";
  const montoFinal = usarDesglose ? totalPorDesglose : (parseFloat(String(montoDirecto).replace(",", ".")) || 0);
  const desgloseParaEnviar = useMemo(() => {
    const out = {};
    DENOMINACIONES.forEach((d) => {
      const q = parseInt(cantidades[d.valor], 10) || 0;
      if (q > 0) out[d.valor] = q;
    });
    return Object.keys(out).length ? out : null;
  }, [cantidades]);

  const cambiarCantidad = (valor, value) => {
    const v = value.replace(/\D/g, "").slice(0, 6);
    setCantidades((prev) => ({ ...prev, [valor]: v }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (montoFinal < 0) return;
    onConfirmar({
      monto_total: Math.round(montoFinal),
      desglose: desgloseParaEnviar,
    });
  };

  return (
    <div className="oc-overlay">
      <div className="oc-modal">
        <h2 className="oc-title">Iniciar caja</h2>
        <p className="oc-text">
          Ingresa el fondo de caja (caja inicial) desglosado por denominación o el monto total.
        </p>

        <form onSubmit={handleSubmit} className="oc-form">
          <div className="oc-section">
            <label className="oc-label">Monto total directo (opcional)</label>
            <input
              type="text"
              inputMode="decimal"
              className="oc-input"
              placeholder="Ej: 50000"
              value={montoDirecto}
              onChange={(e) => setMontoDirecto(e.target.value)}
            />
            <span className="oc-hint">Si ingresas aquí, se usará este monto y no el desglose.</span>
          </div>

          <div className="oc-section">
            <h3 className="oc-subtitle">Desglose por denominación</h3>
            <div className="oc-desglose-grid">
              {DENOMINACIONES.map((d) => (
                <div key={d.valor} className="oc-desglose-row">
                  <label className="oc-desglose-label">{d.label}</label>
                  <input
                    type="number"
                    min="0"
                    step="1"
                    className="oc-input oc-input-num"
                    value={cantidades[d.valor]}
                    onChange={(e) => cambiarCantidad(d.valor, e.target.value)}
                    disabled={!usarDesglose}
                  />
                </div>
              ))}
            </div>
            <p className="oc-total-desglose">
              Total desglose: <strong>{fmtCLP(totalPorDesglose)}</strong>
            </p>
          </div>

          <p className="oc-total-final">
            Caja inicial: <strong>{fmtCLP(montoFinal)}</strong>
          </p>

          <div className="oc-actions">
            <button type="button" className="oc-btn secondary" onClick={onCerrar} disabled={cargando}>
              Cancelar
            </button>
            <button type="submit" className="oc-btn primary" disabled={cargando || montoFinal < 0}>
              {cargando ? "Guardando…" : "Iniciar caja"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
